import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Spinner from "../Components/Spinner";
import { useLanguage } from "../Translations/LenguageContext";
import { Link } from "react-router-dom";
import ErrorMessage from "../Components/ErrorMessage";
import GoogleLogin from "./GoogleLogin";
const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

function Register() {
    const navigate = useNavigate();
    const { t } = useLanguage();
    const [showPassword, setShowPassword] = useState(false);
    const [err, setErr] = useState({ message: "", display: false });
    const [loading, setLoading] = useState(false);
    const [privacyChecked, setPrivacyChecked] = useState(true);
    const [newsletterChecked, setNewsletterChecked] = useState(true)

    const nameRef = useRef(null);
    const surnameRef = useRef(null);
    const emailRef = useRef(null);
    const passwordRef = useRef(null);


    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Enter') {
                startRegister();
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&-])[A-Za-z\d@$!%*?&-]{10,20}$/;

    const validateEmail = (email) => {
        return emailRegex.test(email);
    };

    const validatePassword = (password) => {
        return passwordRegex.test(password);
    };

    function startRegister() {
        setErr({ message: "", display: false })
        const name_reg = nameRef.current;
        const surname_reg = surnameRef.current;
        const email_reg = emailRef.current;
        const password_reg = passwordRef.current;

        let error = false;
        let error_email = false;
        let error_password = false;
        let error_password_repeat = false;

        if (!name_reg.value) {
            error = true;
            name_reg.style.border = "1px solid var(--danger)";
        } else {
            name_reg.style.border = "";
        }

        if (!surname_reg.value) {
            error = true;
            surname_reg.style.border = "1px solid var(--danger)";
        } else {
            surname_reg.style.border = "";
        }

        if (!email_reg.value) {
            error = true;
            email_reg.style.border = "1px solid var(--danger)";
        } else if (!validateEmail(email_reg.value)) {
            error = true;
            error_email = true;
            email_reg.style.border = "1px solid var(--danger)";
        } else {
            email_reg.style.border = "";
        }

        if (!password_reg.value) {
            error = true;
            password_reg.style.border = "1px solid var(--danger)";
        } else if (!validatePassword(password_reg.value)) {
            error = true;
            error_password = true;
            password_reg.style.border = "1px solid var(--danger)";
        } else {
            password_reg.style.border = "";
        }

        const privacy_policy_desc = document.getElementById("privacy_policy_desc");
        if (!privacyChecked) {
            error = true;
            privacy_policy_desc.style.color = "var(--danger)";
        } else {
            privacy_policy_desc.style.color = "";
        }

        if (error) {
            if (error_email) {
                setErr({ message: t.register_form.email_format, display: true });
            } else if (error_password) {
                setErr({ message: t.register_form.password_err, display: true });
            } else if (error_password_repeat) {
                setErr({ message: t.register_form.password_match, display: true });
            } else {
                setErr({ message: t.register_form.red_fields, display: true });
            }
        } else {
            SaveData(name_reg.value, surname_reg.value, email_reg.value, password_reg.value)
        }
    }

    function SaveData(name, surname, email, password) {
        setLoading(true);
        let dataToSave = {
            name: name,
            surname: surname,
            email: email,
            password: password,
            newsletter: newsletterChecked
        };

        fetch(`${GEN_BACKEND_LINK}/register`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dataToSave),
        })
            .then(response => response.json())
            .then(data => {
                setLoading(false);
                if (data.message === "OK") {
                    document.cookie = `account_id=${data.account_id}; path=/; max-age=` + (7 * 24 * 60 * 60);
                    localStorage.setItem("account_id", data.account_id);
                    setErr({ message: "", display: false });
                    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

                    if (isMobile) {
                        navigate("/mobile_device");
                    } else {
                        if (data.email_verified) {
                            navigate("/console/organizations");
                        } else {
                            navigate(`/verify-email?email=${email}`);
                        }
                    }
                } else if (data.error === "email_already_exists") {
                    setErr({ message: t.register_form.email_already_present, display: true });
                } else if (data.error === "invalid_email") {
                    setErr({ message: t.register_form.email_format, display: true });
                } else if (data.error === "missing_fields") {
                    setErr({ message: t.register_form.red_fields, display: true });
                } else if (data.error) {
                    setErr({ message: t.register_form.errors_back, display: true });
                }

            })
            .catch(error => {
                setLoading(false);
                setErr({ message: t.register_form.problem_back, display: true });
            });
    }

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div className="register_container_reg">
            <div className="reg_cont">
                <p className="title_form fade-in">{t.register_form.create_account}</p>
                <div className="persona_reg fade-in">
                    <input ref={nameRef} type="text" id="name_reg" placeholder={t.register_form.name} className="register_form_first person_reg"></input>
                    <input ref={surnameRef} type="text" id="surname_reg" placeholder={t.register_form.surname} className="register_form_first person_reg"></input>
                </div>
                <input ref={emailRef} type="text" id="email_reg" placeholder="Email" className="register_form_first fade-in"></input>
                <div className="password_eye fade-in">
                    <input autoComplete="new-password" ref={passwordRef} type={showPassword ? "text" : "password"} id="password_reg" placeholder="Password" className="register_form_first"></input>
                    <button className="show_passowrd" onClick={togglePasswordVisibility}>
                        <i className={`fa-regular fa-eye${showPassword ? "" : "-slash"}`}></i>
                    </button>
                </div>
                <div className="persona_reg_news_cont">
                    <label className="switch_container">
                        <input
                            id="web-search-toggle"
                            type="checkbox"
                            checked={newsletterChecked}
                            onChange={() => setNewsletterChecked(!newsletterChecked)}
                        />
                        <span className="slider round"></span>
                    </label>
                    <p className="sidebar_choise_btn_title" htmlFor="web-search-toggle">{t.register_form.newsletter}</p>
                </div>


                <ErrorMessage err={err} />
                <button onClick={startRegister} className="start_btn fade-in">
                    {loading ? (
                        <Spinner loading={loading} />
                    ) : (
                        <>
                            {t.register_form.button_register}
                        </>
                    )
                    }
                </button>
                <div className="reg_auth_ext_cont fade-in">
                    <GoogleLogin type_enter={"Register"} />
                </div>
                <p className="already_present fade-in">{t.register_form.already_registered} <span onClick={() => navigate("/login")}> {t.register_form.go_login}</span></p>


            </div>
            <p className="fade-in" id="privacy_policy_desc" dangerouslySetInnerHTML={{__html: t.register_form.privacy_continue}}></p>
        </div>
    );
}

export default Register;
